<!--
  记录页
  jay 2020-01-11
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="
        flag == 2
          ? $t('common.withdrawalRecord')
          : flag == 3
          ? $t('common.transferRecord')
          : flag == 4
          ? $t('common.reservationRecord')
          : $t('common.rechargeRecord')
      "
      :fixed="true"
      left-arrow
      @click-left="_back"
    />

    <vue-filter
      :list="filterList"
      :countflag="flag == 4 ? false : true"
      :countData="filterCount"
      @getFilterData="getFilterData"
    />

    <div
      class="scroll-wrapper"
      :class="{
        noCrad: !listData.length && getListFlag,
        'has-count': flag != 4
      }"
    >
      <div v-if="!listData.length && getListFlag" class="noCard-wrap">
        <img src="@/assets/images/public/pic_kong@2x.png" />
        <p class="text-gray">{{ $t("common.noData") }}</p>
      </div>
      <scroll
        v-if="listData.length && getListFlag"
        ref="scroll"
        :data="listData"
        :pullUpLoad="true"
        :pullDownRefresh="true"
        @pullingDown="pullingDown"
        @pullingUp="pullingUp"
      >
        <ul class="record">
          <li
            v-for="(item, index) in listData"
            :key="index"
            @click="toDetail(item)"
          >
            <img
              class="li-icon"
              :src="
                item.icon
                  ? httpUrl + item.icon
                  : require('@/assets/images/public/logo_icon@2x.png')
              "
            />
            <div class="info">
              <div class="info-l">
                <h3>{{ item.type_name }}</h3>
                <p class="text-gray">{{ item.createtime }}</p>
              </div>
              <div class="info-r">
                <p class="text-blue">
                  {{ item.status }}
                </p>
                <van-button
                  plain
                  size="small"
                  type="info"
                  v-if="flag == 4 && item.extra != ''"
                  @click.stop="clickCancel(item.id)"
                >
                  {{ $t("wallet.cancelReservation") }}
                </van-button>
                <h4 v-if="flag != 4">
                  {{
                    item.money_type == 1
                      ? "+"
                      : item.money_type == 2
                      ? "-"
                      : ""
                  }}{{ item.money }}
                </h4>
              </div>
            </div>
          </li>
        </ul>
      </scroll>
    </div>
  </div>
</template>

<script>
import VueFilter from "@/components/filter";
export default {
  name: "record",
  meta: {
    keepAlive: true
  },
  components: {
    VueFilter
  },
  data() {
    return {
      // 1.充值 2提现 3转账 4预约办卡 5话费充值 6流量充值 100批量话费流量充值 8水费 9电费 10网费 11Grab 12银行 13贷款 14电子钱包 15保险 16房地产 17宿务航空 18政府 19支付网关
      flag: "",
      withdrawType: 0,
      filterList: [{ title: "", list: [] }], //筛选列表
      filterCount: [
        { label: this.$t("common.totalExpenditure"), value: "0.00" }
      ], //筛选统计
      totalMoney: 0, //总支出
      startDate: this._formatDate(new Date()),
      endDate: this._formatDate(new Date()),
      page: 1,
      status: "",
      listData: [],
      getListFlag: false
    };
  },
  created() {
    let vm = this;
    vm.flag = vm.$route.query.flag;
    vm.withdrawType = vm.$route.query.withdrawType || 0;
    if (vm.flag == 1) {
      vm.filterCount = [
        { label: this.$t("common.totalIncome"), value: "0.00" }
      ];
    }
    vm._getStatusList();
  },
  mounted() {},
  computed: {},
  methods: {
    _getStatusList() {
      // 获取状态列表
      let vm = this;
      vm.$post(
        "/app/help/statusList",
        { type: vm.flag },
        { loading: true }
      ).then(res => {
        console.log("statusList", vm.flag, res);
        vm.filterList[0].list = res;
        console.log("filterList", vm.filterList);
        vm._getList();
      });
    },
    pullingDown() {
      // 下拉刷新
      this.page = 1;
      this._getList();
    },
    pullingUp() {
      // 上拉加载
      let vm = this;
      if (vm.pullUpLoadFlag) {
        vm.$refs.scroll.forceUpdate(false);
        return;
      }
      vm.page += 1;
      vm._getList(1);
    },
    toDetail(obj) {
      //跳转详情
      let vm = this;
      if (vm.flag == 4) {
        return;
      }
      if (vm.flag == 100) {
        vm.flag = obj.type;
      }
      let query = { flag: vm.flag, order_id: obj.order_id };
      if (obj.is_batch) {
        query = {
          flag: vm.flag,
          is_batch: obj.is_batch,
          order_id: obj.order_id
        };
      }
      vm.$router.push({
        path: "/detail",
        name: "detail",
        query: query
      });
    },
    getFilterData(data) {
      // 获取筛选数据
      let vm = this;
      vm.startDate = data.startDate;
      vm.endDate = data.endDate;
      vm.status = data.filterList[0].key;
      vm.page = 1;
      vm._getList();
    },
    _getList(flag) {
      //获取列表数据
      let vm = this;
      let params = {};
      params.start_date = vm.startDate;
      params.end_date = vm.endDate;
      params.page = vm.page;
      params.type = vm.flag;
      params.status = vm.status;
      if (vm.flag == 2) {
        params.withdraw_type = vm.withdrawType;
      }
      let loading = true;
      vm.getListFlag = false;
      if (flag) {
        loading = false;
        vm.getListFlag = true;
      }
      vm.$post("/app/recharge/rechargeRecordUser", params, {
        loading: loading,
        alert: true
      }).then(res => {
        vm.getListFlag = true;
        console.log("rechargeRecordUser", res);
        if (res.code == 0) {
          vm.totalMoney = res.data.count;
          vm.filterCount[0].value = vm.totalMoney ? vm.totalMoney : "0.00";
          if (vm.page == 1) {
            vm.listData = res.data.list;
          } else {
            vm.listData = vm.listData.concat(res.data.list);
          }
          if (res.data.list.length < 10) {
            vm.pullUpLoadFlag = true;
          } else {
            vm.pullUpLoadFlag = false;
          }
        } else {
          vm.totalMoney = 0;
          vm.filterCount[0].value = vm.totalMoney ? vm.totalMoney : "0.00";
          vm.listData = [];
        }
      });
    },
    clickCancel(id) {
      // 点击取消预约
      let vm = this;
      vm.setFlag = false;
      vm.$dialog
        .confirm({
          message: vm.$t("wallet.sureCancelReservation")
        })
        .then(() => {
          // 确定删除
          vm.cancelAppointmentCard(id);
        })
        .catch(() => {});
    },
    cancelAppointmentCard(id) {
      // 取消预约
      let vm = this;
      vm.$post(
        "/app/user/cancelAppointmentCard",
        { id: id },
        { loading: true }
      ).then(res => {
        console.log("cancelAppointmentCard", res);
        vm._getList();
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  top: 44px + 50px;
  &.has-count {
    top: 44px + 50px + 38px;
  }
}
.record {
  background: #fff;
  padding: 0 15px;
  li {
    padding: 10px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1.1px solid #e4e4e4;
    .li-icon {
      flex: 0 0 32px;
      margin-right: 10px;
      width: 32px;
      height: 32px;
    }
    .info {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      h3,
      h4,
      p {
        line-height: 1.2;
      }
      h3 {
        font-size: 16px;
        font-weight: 400;
      }
      h4 {
        font-size: 16px;
        font-weight: 400;
        color: #333;
      }
      p {
        font-size: 12px;
      }
      .info-l {
        flex: 1;
        p {
          margin-top: 4px;
        }
      }
      .info-r {
        text-align: right;
        p {
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>
